/* Centres the middle card of the mobile promotion rail (Figma 46:2 shows the Ice Cream Pints arch centred with neighbours peeking). Only the rail scrolls; the heading and copy stay put. */
(function () {
  function centre(grid) {
    if (grid.dataset.adelaideCentred === 'true') return;
    if (grid.scrollWidth <= grid.clientWidth) return;
    grid.scrollLeft = Math.max(0, (grid.scrollWidth - grid.clientWidth) / 2);
    grid.dataset.adelaideCentred = 'true';
  }
  function run() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.adelaide-image-cards--staggered .adelaide-card-grid').forEach(centre);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
